import { render, staticRenderFns } from "./EditUserCompanyPage.vue?vue&type=template&id=9f9008ac&"
import script from "./EditUserCompanyPage.vue?vue&type=script&lang=js&"
export * from "./EditUserCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f9008ac')) {
      api.createRecord('9f9008ac', component.options)
    } else {
      api.reload('9f9008ac', component.options)
    }
    module.hot.accept("./EditUserCompanyPage.vue?vue&type=template&id=9f9008ac&", function () {
      api.rerender('9f9008ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/EditUserCompanyPage.vue"
export default component.exports